import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MaterialModule } from './material/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SwitchCasesDirective } from './directives/switch-cases.directive';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { DateFormats } from './utils/mat-date-formats';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TagInputModule } from 'ngx-chips';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { FilterSaveComponent } from './filter-save/filter-save.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectExtendComponent } from './mat-select-extend/mat-select-extend.component';
import { MatSelectExtendPipe } from './mat-select-extend/mat-select-extend.pipe';

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    '/assets/i18n/',
    '.json?cb=' + new Date().getTime()
  );
}

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    SwitchCasesDirective,
    DateFormatPipe,
    FilterSaveComponent,
    MatSelectExtendComponent,
    MatSelectExtendPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    TranslateModule,
  ],
  exports: [
    ConfirmDialogComponent,
    MaterialModule,
    NgxSpinnerModule,
    SwitchCasesDirective,
    TagInputModule,
    DateFormatPipe,
    TranslateModule,
    MatSelectExtendComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DateFormats },
    {
      provide: MAT_DATE_LOCALE,
      useValue: window.navigator.language.split('-')[0],
    },
  ],
})
export class SharedModule {}
